import { cva } from 'class-variance-authority';

import { gapScaleVariants } from '@/lib/shared-variants';

/**
 * Popover content container styles
 * Floating panel with shadow and rounded corners
 */
export const popoverContentVariants = cva(
  [
    // Base styles
    'z-50',
    'flex',
    'flex-col',
    'bg-surface',
    'border',
    'border-outline',
    'rounded-sm',
    'shadow-[0px_4px_16px_rgba(0,0,0,0.12)]',
    // Animations
    'data-[state=open]:animate-in',
    'data-[state=closed]:animate-out',
    'data-[state=closed]:fade-out-0',
    'data-[state=open]:fade-in-0',
    'data-[state=closed]:zoom-out-95',
    'data-[state=open]:zoom-in-95',
    // Side-specific animations
    'data-[side=bottom]:slide-in-from-top-2',
    'data-[side=left]:slide-in-from-right-2',
    'data-[side=right]:slide-in-from-left-2',
    'data-[side=top]:slide-in-from-bottom-2',
  ],
  {
    variants: {
      scale: {
        s: ['p-sm', 'min-w-[200px]', 'max-w-[280px]', gapScaleVariants.s],
        m: ['p-md', 'min-w-[240px]', 'max-w-[320px]', gapScaleVariants.m],
        l: ['p-lg', 'min-w-[280px]', 'max-w-[400px]', gapScaleVariants.l],
      },
    },
    defaultVariants: {
      scale: 'm',
    },
  }
);

/**
 * Popover arrow styles
 * White triangle with drop shadow to match popover
 * Dimensions: 14px x 7px from Figma
 */
export const popoverArrowVariants = cva([
  'fill-surface',
  'drop-shadow-[0px_2px_4px_rgba(0,0,0,0.1)]',
]);

/**
 * Popover close button styles
 * Optional close button inside popover content
 */
export const popoverCloseVariants = cva([
  'inline-flex',
  'items-center',
  'justify-center',
  'rounded-radius-xs',
  'text-foreground-secondary',
  'hover:text-foreground',
  'hover:bg-transparent-hover',
  'focus-visible:outline-none',
  'focus-visible:ring-2',
  'focus-visible:ring-focus',
  'focus-visible:ring-offset-2',
  'disabled:pointer-events-none',
  'disabled:opacity-50',
  'transition-colors',
  'duration-150',
]);
